import { useEffect, useState } from 'react';
import { api, fmtCRC, fmtDate, dueLabel, daysUntil } from '../api';
import { IconCheck } from '../components/Icons';
import PlatformVisual from '../components/PlatformVisual';

function AccountRow({ a, onPay }) {
  const d = a.nextRenewal ? daysUntil(a.nextRenewal) : null;
  const color = d == null ? 'text-slate-500' : d < 0 ? 'text-red-400' : d <= 3 ? 'text-amber-400' : 'text-slate-400';
  return (
    <div className="card flex flex-wrap items-center gap-3">
      <PlatformVisual platform={a} size="md" />
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium">{a.platform}</div>
        <div className="truncate text-sm text-slate-400">{a.email || (a.kind === 'perfiles' ? 'Perfiles sueltos' : '—')}</div>
      </div>
      <div className="text-right text-sm">
        <div className="font-semibold">{fmtCRC(a.cost)}</div>
        {a.nextRenewal && <div className={`text-xs ${color}`}>{fmtDate(a.nextRenewal)} · {dueLabel(a.nextRenewal)}</div>}
      </div>
      {a.paidThisPeriod ? (
        <span className="badge inline-flex items-center gap-1 bg-emerald-500/20 text-emerald-300"><IconCheck size={14} /> pagada</span>
      ) : (
        <button className="btn-success" onClick={() => onPay(a)}>Marcar pagada</button>
      )}
    </div>
  );
}

export default function Renovaciones() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState('hoy');

  const load = () => api('/renovaciones').then(setData).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const pay = async (a) => {
    if (!confirm(`¿Registrar el pago de ${a.platform} por ${fmtCRC(a.cost)}?`)) return;
    await api(`/renovaciones/${a._id}/pay`, { method: 'POST', body: { amount: a.cost } });
    load();
  };

  if (!data) return <p className="text-slate-400">Cargando…</p>;

  const tabs = [
    ['hoy', `Vencen hoy (${data.today.length})`],
    ['proximas', `Próximas (${data.upcoming.length})`],
    ['historial', `Historial (${data.history.length})`],
  ];

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-bold">Renovaciones</h1>
        <div className="card px-4 py-2 text-sm">
          Costo mensual de tus cuentas: <span className="font-bold text-indigo-300">{fmtCRC(data.monthCost)}</span>
        </div>
      </div>
      <p className="text-sm text-slate-500">Aquí ves cuándo debes pagar las cuentas que compraste a tus proveedores (las del Banco de Cuentas).</p>

      <div className="flex flex-wrap gap-2">
        {tabs.map(([k, label]) => (
          <button key={k} onClick={() => setTab(k)} className={`badge cursor-pointer ${tab === k ? 'bg-indigo-600 text-white' : 'bg-slate-800 text-slate-400'}`}>{label}</button>
        ))}
      </div>

      {tab === 'hoy' && (
        <div className="space-y-3">
          {data.today.length === 0 && <p className="text-slate-500">Nada que pagar hoy.</p>}
          {data.today.map((a) => <AccountRow key={a._id} a={a} onPay={pay} />)}
        </div>
      )}

      {tab === 'proximas' && (
        <div className="space-y-3">
          {data.upcoming.length === 0 && <p className="text-slate-500">No hay renovaciones programadas. Agrega el "día de renovación" a tus cuentas en el Banco.</p>}
          {data.upcoming.map((a) => <AccountRow key={a._id} a={a} onPay={pay} />)}
        </div>
      )}

      {tab === 'historial' && (
        <div className="card overflow-x-auto p-0">
          <table className="w-full min-w-[520px] text-sm">
            <thead>
              <tr className="border-b border-slate-800 text-left text-slate-400">
                <th className="p-3">Fecha</th>
                <th className="p-3">Cuenta</th>
                <th className="p-3">Período</th>
                <th className="p-3">Monto</th>
              </tr>
            </thead>
            <tbody>
              {data.history.map((h) => (
                <tr key={h._id} className="border-b border-slate-800/50">
                  <td className="p-3 text-slate-400">{fmtDate(h.date)}</td>
                  <td className="p-3">{h.accountId?.platformId?.name || '—'} <span className="text-slate-500">{h.accountId?.email || ''}</span></td>
                  <td className="p-3 text-slate-400">{h.periodMonth || '—'}</td>
                  <td className="p-3 font-medium">{fmtCRC(h.amount)}</td>
                </tr>
              ))}
              {data.history.length === 0 && (
                <tr><td colSpan="4" className="p-6 text-center text-slate-500">Aún no has registrado pagos de renovación.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
